var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.back_button_wrap, ( _obj = {}, _obj[_vm.$style.no_mobile] = _vm.noMobile, _obj )],style:({
    margin: _vm.margin,
    padding: _vm.padding
  })},[_c('a',{attrs:{"href":_vm.href},on:{"click":function($event){return _vm.$emit('click')}}},[_c('base-icon',{attrs:{"name":"arrow-left","size":"14px"}}),_c('span',{class:_vm.$style.back_button_label},[_vm._t("default",function(){return [_vm._v("戻る")]})],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }